import React from 'react';
import { SearchPipeline } from './searchPipelineConfig';

interface SearchStepperProps {
  pipeline: SearchPipeline;
}

const SearchStepper: React.FC<SearchStepperProps> = ({ pipeline }) => (
  <nav
    aria-label="Search progress"
    className="hidden md:flex w-full items-start justify-center overflow-x-auto pb-2 mt-4 select-none"
  >
    {pipeline.steps.map((step, index) => {
      const isLast = index === pipeline.steps.length - 1;
      return (
        <React.Fragment key={step.id}>
          <div
            className="flex min-w-[88px] max-w-[132px] flex-col items-center"
            aria-current={step.state === 'active' ? 'step' : undefined}
          >
            <div
              className={`flex h-8 w-8 items-center justify-center rounded-full border-2 text-sm font-semibold transition-colors duration-200 motion-reduce:transition-none ${
                step.state === 'done'
                  ? 'border-primary bg-primary text-white'
                  : step.state === 'active'
                    ? 'border-primary bg-white text-primary shadow-sm'
                    : 'border-gray-300 bg-white text-gray-500'
              }`}
            >
              {step.state === 'done' ? (
                <svg aria-hidden className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span className={`mt-2 text-center text-xs font-semibold leading-tight ${
              step.state === 'active'
                ? 'text-primary'
                : step.state === 'done'
                  ? 'text-gray-700'
                  : 'text-gray-500'
            }`}>
              {step.compactLabel}
            </span>
          </div>
          {!isLast && (
            <div
              aria-hidden
              className={`mt-3.5 h-0.5 min-w-8 flex-1 rounded transition-colors duration-200 motion-reduce:transition-none ${
                step.state === 'done' ? 'bg-primary' : 'bg-gray-200'
              }`}
            />
          )}
        </React.Fragment>
      );
    })}
  </nav>
);

export default SearchStepper;
